import type {ViewerAPI} from '@wix/viewer-manager-interface'
import {VIEW_MODES} from './constants/constants'

const getViewMode = (viewer: ViewerAPI): string =>
    viewer.viewMode.isMobileView() ? VIEW_MODES.MOBILE : VIEW_MODES.DESKTOP

const isSameViewMode = (viewer: ViewerAPI, type?: string): boolean => type === getViewMode(viewer)

export {isSameViewMode, getViewMode}
